import React from 'react';
import { FormattedMessage } from 'react-intl';

export const DeliveryTimeLabel = () => (
  <FormattedMessage defaultMessage='Delivery' description='fulfillmentPlanner.deliveryTime' id='YYtfh9' />
);
